import type { WalletRecipientView } from '@/api/address-book-bff/types';

/** Identity as the API supplies it — safe for avatar initials and image alt text. */
export const getRecipientName = (recipient: WalletRecipientView): string =>
  recipient.name ?? 'Contact';

/** Display text: the sender is marked as themselves, which the API never does. */
export const getRecipientLabel = (recipient: WalletRecipientView): string => {
  if (!recipient.isSelf) return getRecipientName(recipient);

  return recipient.name ? `${recipient.name} (You)` : 'You';
};
